// extracted by mini-css-extract-plugin
var _1 = "Timer_button__6+b2c";
var _2 = "Timer_timerIcon__FIsxh";
var _3 = "Timer_wrapper__0S0-u";
var _4 = "Timer_wrapperActive__yU3M-";
var _5 = "Timer_wrapperCard__fIapm";
var _6 = "Timer_wrapperCardModal__2h4Lb";
var _7 = "Timer_wrapperHoverable__Gcs-G";
export { _1 as "button", _2 as "timerIcon", _3 as "wrapper", _4 as "wrapperActive", _5 as "wrapperCard", _6 as "wrapperCardModal", _7 as "wrapperHoverable" }
